import React from "react";

function QualityAbout() {
  return (
    <div>
      <section className="section-Quality">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 className="mt-4 text-center text-white wow animate__animated animate__fadeInDown">
                الجودة التي نتميز بها
              </h2>
            </div>
            <div
              className="col-md-12 wow animate__animated animate__fadeInRight"
              dir="rtl"
            >
              <p className="text-white">✔️ القلي بزيوت نباتية عالية الجودة</p>
              <p className="text-white">
                ✔️ معايرة بأحدث الأجهزة وفق أعلى المعايير الصحية
              </p>
              <p className="text-white">✔️ منتج قليل الكربوهيدرات</p>
              <p className="text-white">
                ✔️ نكهات طبيعية من شركة Givaudan العالمية
              </p>
              <p className="text-white">
                ✔️ بدون ألوان صناعية أو إضافات كيميائية
              </p>
              <p className="text-center text-success h4">
                <b>قرمشة مثالية ✨ لون ذهبي ✨ طعم لا يُقاوم</b>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default QualityAbout;
